module.exports = __webpack_public_path__ + "img/19_44.2e28b2da.png";